import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

type CancelReturnRequestParams = {
	returnRequestId: string;
	shopId: string;
};

export default function useCancelReturnRequest() {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateReturnRequest = useInvalidateReturnRequest();
	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/cancel",
	);

	return useMutation({
		onSuccess: (_, { returnRequestId, shopId }) => {
			successNotification();
			invalidateReturnRequest({ returnRequestId, shopId });
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async ({
			returnRequestId,
			shopId,
		}: CancelReturnRequestParams) => {
			return mutation.mutateAsync({
				params: { path: { returnRequestId, shopId } },
			});
		},
	});
}
